var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"direction":"vertical"}},[_c('page-header',{ref:"header",class:{'fixed': _vm.isScroll},attrs:{"menu":_vm.menu,"site-info":_vm.siteInfo,"is-sub":_vm.isSubSite}}),_c('div',{staticClass:"pages-main"},[_c('router-view')],1),_c('page-footer',{attrs:{"site-info":_vm.siteInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }